export default {
  // Errors
  canNotDeleteFiscalCurrency: 'امکان حذف ارز محاسباتی وجود ندارد',
  canNotDeleteBaseCurrency: 'امکان حذف ارز پایه وجود ندارد',
  canNotDeleteDisplayCurrency: 'امکان حذف ارز نمایشی وجود ندارد',
  duplicateId: 'شناسه تکراری است',
  notFound: 'ارز یافت نشد',

  // Words
  baseCurrency: 'ارز پایه',
  currencyRemoved: 'ارز حذف شد',
  currencySettingsUpdated: 'تنظیمات ارز بروز رسانی شد',
  currencyUpdated: 'ارز به روز رسانی شد',
  displayCurrency: 'ارز نمایشی',
  displayRate: 'نرخ تبدیل',
  enterBaseCurrency: 'نام ارز پایه را وارد کنید',
  enterFiscalCurrency: 'نام ارز محاسباتی را وارد کنید',
  enterDisplayCurrency: 'نام ارز نمایشی را وارد کنید',
  fiscalCurrency: 'ارز محاسباتی',
  newCurrencyAdded: 'ارز جدید افزوده شد',
  rate: 'نرخ تبدیل',
  symbol: 'نماد'
}
